import i18next from "i18next"
import I18NextVue from "i18next-vue"
import LanguageDetector from 'i18next-browser-languagedetector'
import { en, cn, es, de, br, fr, hi } from "@/locales"

const i18nPlugin = {
    ready: new Promise(() => { }),
    install(app, options) {
        this.ready = new Promise(async (resolve) => {
            const { useDadStore } = await import('@/store/dad')
            const store = useDadStore()

            i18next.use(LanguageDetector)
            i18next.init({
                lng: store.language,
                interpolation: {
                    escapeValue: false
                },
                fallbackLng: false,
                resources: {
                    en,
                    cn,
                    es,
                    de,
                    br,
                    fr,
                    hi
                }
            })

            app.use(I18NextVue, { i18next })

            resolve()
        })
    }
}

export default i18nPlugin